import { createReducer } from '@reduxjs/toolkit';
import { IHFileUploads } from 'components/FileUploads';
import { switchAccountSuccess } from 'store/account/actions';
import * as actions from './actions';

export interface FileUploadState {
  error: null | Error;
  data: IHFileUploads[];
}

export const fileUploadDefaultState: FileUploadState = {
  error: null,
  data: []
};

const fileUploadsReducer = createReducer(fileUploadDefaultState, {
  [actions.ADD_FILE_TO_UPLOAD]: (state, action) => {
    const newArray = [...state.data, ...action.payload];
    state.data = newArray;
  },
  [actions.REMOVE_FILE_TO_UPLOAD]: (state, action) => {
    state.data = state.data.filter(obj => obj.file?.uri !== action.payload);
  },
  [actions.CLEAR_FILE_UPLOADS]: () => fileUploadDefaultState,
  [switchAccountSuccess.type]: () => fileUploadDefaultState
});

export default fileUploadsReducer;
